import { logger } from '@fe/core';
import type { StarmapCubemap, StarmapProvider, StarmapTarget } from '@fe/maplibre-extensions';
import StarmapWorker from '../worker/starmap-worker.ts?worker';
import type { StarmapWorkerRequest, StarmapWorkerResponse } from '../worker/starmap-worker';

// The worker is created per request and terminated as soon as it answers. The
// starmap loads once per session (twice if the user switches variant)
let nextId = 1;

function transcode(url: string, basisFormat: number): Promise<StarmapCubemap> {
    return new Promise<StarmapCubemap>((resolve, reject) => {
        const worker = new StarmapWorker({ name: 'fe-starmap-worker' });
        const id = nextId++;

        const cleanup = () => {
            worker.onmessage = null;
            worker.onerror = null;
            worker.terminate();
        };

        worker.onmessage = (e: MessageEvent<StarmapWorkerResponse>) => {
            if (e.data.id !== id) {
                return;
            }
            if (e.data.ok) {
                const { fetchMs, initMs, transcodeMs, totalBytes } = e.data.timing;
                logger.debug(
                    'Starmap %s transcoded off-thread: fetch %dms, transcoder init %dms, transcode %dms, %d MB GPU data',
                    url,
                    Math.round(fetchMs),
                    Math.round(initMs),
                    Math.round(transcodeMs),
                    Math.round(totalBytes / 1024 / 1024)
                );
                resolve(e.data.cube);
            } else {
                reject(new Error(e.data.error));
            }
            cleanup();
        };

        worker.onerror = (e) => {
            reject(new Error(`starmap worker error: ${e.message}`));
            cleanup();
        };

        const request: StarmapWorkerRequest = { id, url, basisFormat };
        worker.postMessage(request);
    });
}

export function createStarmapProvider(url: string): StarmapProvider {
    return (target: StarmapTarget) => transcode(url, target.basisFormat);
}



